import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: (p) => p.spacing(3),
};

export const emptyIcon: SxStyle = {
  backgroundColor: (p) => p.palette.common.white,
  color: (p) => p.palette.grey[400],
};

export const emptyIconWrapper: SxStyle = {
  display: 'flex',
  padding: (p) => p.spacing(1.5),
  borderRadius: (p) => p.spacing(2),
  background: (p) => p.palette.common.white,
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
};

export const notFoundTitleWrapper: SxStyle = {
  display: 'flex',
  textAlign: 'center',
  padding: (p) => p.spacing(1, 2),
  boxShadow: `
            0 6px 6px -4px rgba(0,0,0,0.05),
            0 12px 16px -8px rgba(0,0,0,0.06)
          `,
};

export const notFoundTitle: SxStyle = {
  fontSize: (p) => p.typography.body4.fontSize,
  fontWeight: (p) => p.typography.fontWeightMedium,
  color: (p) => p.palette.grey[500],
};
